import type { FC } from "react";
import { ActivityDetailPage } from "web_myplann/Activities/Pages/ActivityDetailPage";
import { ActivityDetailV2Page } from "web_myplann/Activities/Pages/ActivityDetailV2Page";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";

export const ActivityDetailPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <ActivityDetailV2Page /> : <ActivityDetailPage />;
};
